import { lazy } from 'react'


export default [
    {
        path:"/report/kualitatif/:id",
        component:lazy(() => import('../../views/report/kualitatif/Kualitatif')),
        exact:true,
    },
    {
        path:"/report/kualitatif/:id/:type",
        component:lazy(() => import('../../views/report/kualitatif/Kualitatif')),
        exact:true,
    },
    {
        path:"/report/kuantitatif/:id",
        component:lazy(() => import('../../views/report/kuantitatif/Kuantitatif')),
        exact:true,
    },
    {
        path:"/report/all",
        component:lazy(() => import('../../views/report/all/AllReport')),
        exact:true,
    },
    {
        path:"/report/kejati",
        component:lazy(() => import('../../views/report/kejati/')),
        exact:true,
    },
    
 
]